import { ThirdPartyLogo, LegacyCard } from "@octopusdeploy/design-system-components";
import type { InsightsReportResource } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import InternalLink from "~/components/Navigation/InternalLink";
import { resolveUrl } from "~/utils/resolveUrl";
interface InsightsReportCardProps {
    report: InsightsReportResource;
}
export function InsightsReportCard({ report }: InsightsReportCardProps) {
    return (<LegacyCard logo={<ThirdPartyLogo url={resolveUrl(report.Links.Logo)}/>} header={report.Name} link={<InternalLink to={links.insightsReportOverviewPage.generateUrl({ spaceId: report.SpaceId, reportId: report.Id })}/>} content={report.Description}/>);
}
